<div class="row text-left justify-content-md-center mt-5">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title" id="basic-layout-form">{{ 'account.login.title' | translate }}</h4>
        <p class="mb-0">{{ 'account.login.text' | translate }}</p>
      </div>
      <div class="card-body">
        <div class="px-3">
          <form class="form" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
            <h4 class="form-section"><i class="ft-cpu"></i> {{ 'account.login.detailsHeader' | translate }}</h4>

            <!-- UserName -->
            <div class="form-group">
              <label for="UserName">{{ 'account.login.userNameFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icon-user"></i>
                  </span>
                </div>
                <input type="text" id="UserName" class="form-control" name="UserName" #UserName="ngModel"
                       placeholder="{{'account.login.userNameFieldPlaceHolder' | translate}}"
                       autocomplete="username"
                       [(ngModel)]="userLogin.UserName" required>
              </div>
            </div>

            <!-- Password -->
            <div class="form-group">
              <label for="Password">{{ 'account.login.passwordFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-lock"></i>
                  </span>
                </div>
                <input type="password" id="Password" class="form-control" name="Password" #Password="ngModel"
                       placeholder="{{'account.login.passwordFieldPlaceHolder' | translate}}"
                       autocomplete="current-password"
                       [(ngModel)]="userLogin.Password" required>
              </div>
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary btn-raised mr-1" [disabled]="!loginForm.valid">
                <i class="ft-log-in"></i> {{ 'buttons.loginText' | translate }}
              </button>
              <button type="button" class="btn btn-outline-primary mr-1"
                      [routerLink]="['/account/forgot-password']">{{ 'buttons.forgotPasswordText' | translate }}
              </button>
              <!--              <button type="button" class="btn btn-outline-primary mr-1" [routerLink]="['/account/confirm-email']">Confirm Email</button>-->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
